import { Link } from 'react-router-dom';
import type { Booking } from '../api/types';
import { BOOKING_STATUS, formatDate } from '../format';
import { Badge } from '../ui/kit';

export function BookingItem({ b }: { b: Pick<Booking, 'id' | 'reference' | 'status' | 'guest' | 'roomType' | 'room' | 'checkIn' | 'checkOut' | 'nights'> & { source?: string } }) {
  const st = BOOKING_STATUS[b.status] ?? { label: b.status, tone: '' as const };
  return (
    <Link to={`/bookings/${b.id}`} className="item">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <span className="title">{b.guest.fullName}</span>
        <span className="row">
          {b.source === 'WEBSITE' && b.status === 'PENDING' ? <Badge tone="info">From the website</Badge> : null}
          <Badge tone={st.tone}>{st.label}</Badge>
        </span>
      </div>
      <div className="row small muted">
        <span className="num">{b.reference}</span>
        <span>·</span>
        <span>{b.room ? `Room ${b.room.number}` : b.roomType.name}</span>
        <span>·</span>
        <span>
          {formatDate(b.checkIn)} → {formatDate(b.checkOut)} ({b.nights} {b.nights === 1 ? 'night' : 'nights'})
        </span>
      </div>
    </Link>
  );
}

export function PageHead({ eyebrow, title, children }: { eyebrow?: string; title: string; children?: React.ReactNode }) {
  return (
    <div className="page-head">
      <div>
        {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
        <h1 className="h1">{title}</h1>
      </div>
      {children ? <div className="row">{children}</div> : null}
    </div>
  );
}
